var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-spinner"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-progress-circular',{staticClass:"spinner-progress",attrs:{"indeterminate":"","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }